import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 622.000000 547.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M3453 3701 l-20 -70 30 -12 c17 -7 49 -27 71 -44 23 -17 61 -42 84
-55 41 -23 45 -24 57 -7 6 9 17 17 23 17 11 0 42 38 42 52 0 4 -7 5 -15 2 -9
-4 -15 0 -15 10 0 8 -12 22 -27 30 -16 8 -23 15 -18 16 25 1 -156 130 -182
130 -6 0 -19 -31 -30 -69z m142 -151 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6
0 13 -4 16 -10z"/>
<path d="M3369 3473 c-13 -32 -25 -60 -27 -64 -2 -4 18 -17 43 -29 25 -12 45
-25 45 -30 0 -4 14 -13 30 -20 17 -7 30 -15 30 -19 0 -4 9 -7 19 -7 11 0 19 3
19 6 -1 3 4 18 10 33 9 22 17 27 32 22 15 -5 18 -3 14 9 -3 9 -10 13 -15 10
-5 -3 -6 2 -3 10 3 9 -3 20 -15 28 -12 7 -21 18 -21 25 0 11 -109 83 -127 83
-5 0 -20 -26 -34 -57z"/>
<path d="M2268 3481 c-78 -91 -182 -298 -204 -406 -14 -67 -24 -134 -30 -198
l-7 -69 255 4 c194 2 259 6 271 16 9 8 21 11 27 7 13 -8 107 24 121 41 6 7
-11 4 -40 -7 -28 -10 -77 -21 -111 -23 -54 -4 -60 -3 -60 14 0 12 -5 17 -13
14 -13 -5 -107 30 -107 40 0 3 7 3 15 0 9 -4 15 0 15 9 0 10 -7 13 -20 10 -12
-3 -29 2 -39 11 -11 10 -21 13 -22 7 -2 -5 -25 -11 -52 -12 -42 -2 -51 1 -82
32 -19 19 -35 40 -35 47 0 21 -20 13 -20 -8 0 -11 7 -20 15 -20 8 0 15 -7 15
-15 0 -21 -12 -19 -33 5 -19 22 -24 90 -6 90 5 0 7 5 4 10 -13 22 -35 -12 -35
-54 0 -32 -3 -38 -11 -26 -8 11 -9 -4 -6 -55 3 -38 1 -61 -3 -50 -6 16 -8 12
-14 -19 -5 -28 -4 -42 6 -48 10 -8 10 -9 -2 -5 -9 2 -14 15 -13 33 3 64 23
184 32 202 6 11 8 22 4 25 -6 7 28 100 58 158 11 20 19 43 19 50 0 15 80 140
113 176 11 13 18 25 16 28 -3 2 -12 -4 -21 -14z"/>
<path d="M3886 3372 c-4 -11 -20 -25 -37 -32 -16 -7 -32 -16 -35 -21 -2 -5 13
-47 35 -94 54 -113 86 -245 93 -377 l2 -38 73 0 73 0 0 53 c0 57 -14 149 -32
207 -27 89 -51 150 -59 150 -5 0 -9 3 -8 8 2 14 -14 52 -22 52 -5 0 -6 6 -3
14 3 7 -5 22 -18 32 -13 11 -31 30 -40 42 -15 23 -16 23 -22 4z"/>
<path d="M3248 3251 c-21 -33 -38 -61 -38 -64 0 -4 19 -12 43 -19 23 -6 44
-15 47 -19 9 -12 70 19 70 36 0 8 5 14 12 13 20 -5 21 33 1 48 -23 19 -92 64
-95 63 -2 0 -20 -26 -40 -58z"/>
<path d="M3680 3237 c0 -10 -5 -16 -12 -14 -6 1 -14 -9 -18 -23 -4 -17 -8 -21
-14 -12 -4 6 -12 12 -17 12 -13 0 -1 -63 12 -68 5 -2 9 -11 9 -20 0 -9 6 -29
14 -44 18 -35 44 -150 47 -210 l3 -48 74 0 75 0 -7 73 c-8 81 -68 273 -85 270
-6 -2 -8 4 -5 12 5 11 2 13 -10 9 -10 -4 -16 -1 -16 7 0 8 -11 27 -25 43 -18
21 -25 25 -25 13z"/>
<path d="M3490 3079 c0 -5 -4 -7 -10 -4 -5 3 -10 -1 -10 -9 0 -17 -34 -39 -44
-29 -3 3 -6 -1 -6 -10 0 -9 5 -19 10 -22 6 -4 8 -16 4 -27 -3 -11 -2 -18 2
-15 9 5 10 1 20 -95 l6 -58 74 0 c41 0 74 3 74 8 0 4 -5 36 -11 71 -10 64 -70
197 -82 184 -4 -3 -7 -1 -7 5 0 7 -4 12 -10 12 -5 0 -10 -5 -10 -11z"/>
<path d="M2780 2925 c-7 -8 -8 -15 -2 -15 5 0 15 7 22 15 7 8 8 15 2 15 -5 0
-15 -7 -22 -15z"/>
<path d="M2730 2900 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M2578 2893 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M2550 2881 c0 -8 41 -23 47 -17 2 1 -8 8 -22 14 -14 6 -25 8 -25 3z"/>
<path d="M2510 2870 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2030 2634 l0 -74 68 1 67 1 -35 13 -35 13 65 2 c36 1 77 1 93 0 15
-1 27 3 27 9 0 6 9 11 19 11 10 0 22 7 25 16 3 8 10 13 15 10 5 -3 14 1 21 9
7 9 23 13 36 11 13 -3 24 0 24 5 0 5 10 9 23 10 12 1 2 5 -23 10 -25 5 -68 8
-97 6 -28 -2 -55 -1 -60 3 -4 4 -59 10 -120 13 l-113 5 0 -74z m47 50 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m156 -1 c-7 -2 -21 -2 -30 0
-10 3 -4 5 12 5 17 0 24 -2 18 -5z m-172 -37 c5 3 9 -4 9 -16 0 -12 -4 -19 -9
-16 -5 4 -12 0 -14 -6 -3 -7 -5 3 -5 22 0 19 2 29 5 22 2 -6 9 -10 14 -6z m14
-66 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10 5 0 13 -4 16 -10z"/>
<path d="M3350 2703 c0 -6 -21 -34 -46 -62 -33 -37 -59 -55 -92 -65 -44 -14
-34 -15 172 -15 129 -1 245 4 283 11 50 9 69 9 84 0 12 -8 74 -12 185 -12
l166 0 -4 73 -4 72 -129 0 c-72 -1 -184 -3 -250 -5 -66 -2 -175 0 -242 4 -84
6 -123 6 -123 -1z"/>
<path d="M2832 2646 c-57 -28 -101 -54 -98 -57 4 -3 -13 -7 -36 -7 -24 -1 -56
-6 -73 -11 -21 -7 17 -10 129 -10 217 -1 259 14 268 94 2 19 10 32 23 37 11 3
-9 6 -45 5 -57 0 -77 -6 -168 -51z"/>
<path d="M2513 2683 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M2353 2323 c-18 -6 -16 -42 2 -49 8 -4 22 -1 30 6 24 20 -1 54 -32
43z"/>
<path d="M2902 2321 c-20 -12 -10 -46 13 -46 14 0 20 7 20 24 0 27 -13 35 -33
22z"/>
<path d="M3804 2316 c-9 -24 4 -48 23 -44 12 2 18 12 18 28 0 29 -32 41 -41
16z"/>
<path d="M2710 2193 c0 -113 2 -124 18 -121 13 2 18 16 22 62 3 41 10 62 22
70 27 16 39 -4 41 -70 2 -51 5 -59 22 -59 18 0 20 7 19 74 -1 87 -15 106 -74
96 -35 -6 -35 -6 -35 31 0 27 -4 38 -17 40 -16 2 -18 -9 -18 -123z"/>
<path d="M3631 2311 c-8 -6 -13 -43 -14 -122 -1 -107 0 -114 18 -114 17 0 20
8 23 57 3 59 18 83 45 72 12 -4 17 -22 19 -67 3 -54 5 -62 23 -62 17 0 21 8
23 45 5 65 -13 118 -43 126 -13 3 -33 3 -44 -1 -19 -6 -21 -2 -21 29 0 38 -9
49 -29 37z"/>
<path d="M1490 2270 c0 -29 13 -40 25 -20 3 6 24 10 46 10 50 0 79 -27 79 -74
0 -40 -37 -76 -76 -76 -23 0 -24 4 -24 58 0 68 -6 79 -32 55 -14 -13 -18 -31
-18 -85 l0 -68 50 0 c88 0 135 30 140 90 5 59 -1 83 -29 111 -27 26 -36 29
-95 29 l-66 0 0 -30z"/>
<path d="M2528 2270 c-29 -29 -30 -34 -26 -92 5 -75 35 -108 97 -108 46 0 86
28 72 49 -8 12 -14 12 -39 2 -40 -17 -67 -7 -82 30 -27 65 28 134 81 101 17
-11 24 -11 36 0 13 11 12 14 -7 30 -36 29 -96 24 -132 -12z"/>
<path d="M3970 2184 l0 -116 65 4 c50 3 70 9 90 28 50 47 42 150 -14 183 -18
11 -50 17 -85 17 l-56 0 0 -116z m133 44 c34 -46 7 -102 -55 -113 l-38 -7 0
76 0 77 37 -3 c25 -2 42 -11 56 -30z"/>
<path d="M4247 2293 c-12 -20 -77 -197 -77 -209 0 -23 28 -16 46 11 13 20 25
25 59 25 35 0 44 -4 53 -25 7 -15 20 -25 33 -25 11 0 19 4 17 8 -1 5 -21 57
-43 115 -34 91 -43 107 -62 107 -12 0 -24 -3 -26 -7z m41 -86 c17 -46 16 -47
-19 -47 -26 0 -30 3 -24 18 4 9 10 27 12 40 7 31 17 28 31 -11z"/>
<path d="M4370 2280 c0 -16 6 -20 30 -20 l30 0 0 -95 c0 -88 2 -95 20 -95 18
0 20 8 22 93 l3 92 33 3 c25 3 32 8 30 20 -3 14 -18 18 -86 20 -77 3 -82 2
-82 -18z"/>
<path d="M4567 2198 c-21 -57 -37 -109 -37 -116 0 -21 34 -9 45 16 8 18 18 22
57 22 42 0 48 -3 54 -25 6 -24 37 -35 47 -17 2 4 -14 54 -37 112 -36 91 -45
105 -67 108 -23 3 -27 -4 -62 -100z m79 7 c19 -45 19 -45 -17 -45 -24 0 -30 3
-25 16 3 9 9 27 12 40 8 32 12 30 30 -11z"/>
<path d="M1736 2229 c-24 -19 -27 -27 -24 -72 2 -41 8 -54 30 -70 62 -46 139
14 124 96 -12 64 -78 87 -130 46z m75 -29 c21 -12 25 -41 9 -71 -12 -21 -40
-25 -58 -7 -24 24 -9 88 21 88 4 0 17 -5 28 -10z"/>
<path d="M1900 2158 c0 -81 2 -88 20 -88 18 0 20 7 20 58 0 53 2 60 25 70 14
6 25 20 25 30 0 15 -8 19 -45 19 l-45 0 0 -89z"/>
<path d="M2028 2239 c-23 -13 -12 -42 13 -34 26 9 59 -3 59 -21 0 -10 -12 -14
-40 -14 -33 0 -42 -4 -52 -25 -9 -19 -8 -29 6 -49 14 -22 22 -25 73 -23 l56 2
-2 70 c-1 57 -6 73 -23 88 -22 19 -64 22 -90 6z m72 -108 c0 -21 -22 -33 -45
-25 -18 7 -19 16 -3 32 19 19 48 15 48 -7z"/>
<path d="M2160 2248 c0 -2 14 -41 30 -87 36 -101 37 -111 6 -111 -20 0 -36
-16 -36 -36 0 -2 17 -4 38 -4 34 0 40 4 56 38 23 46 66 171 66 189 0 33 -35 5
-50 -39 -9 -26 -19 -50 -22 -53 -3 -3 -14 18 -24 47 -15 40 -25 54 -42 56 -12
2 -22 2 -22 0z"/>
<path d="M2350 2160 c0 -83 1 -90 20 -90 19 0 20 7 20 90 0 83 -1 90 -20 90
-19 0 -20 -7 -20 -90z"/>
<path d="M2895 2238 c-3 -7 -4 -47 -2 -88 3 -67 5 -75 23 -75 17 0 19 7 19 85
0 73 -2 85 -18 88 -9 2 -19 -2 -22 -10z"/>
<path d="M2980 2158 c0 -81 2 -88 20 -88 18 0 20 7 20 58 0 53 2 60 25 70 14
6 25 20 25 30 0 15 -8 19 -45 19 l-45 0 0 -89z"/>
<path d="M3108 2243 c-38 -10 -13 -39 32 -39 25 1 35 -4 38 -16 3 -15 -4 -18
-38 -18 -34 0 -42 -4 -50 -26 -7 -17 -7 -32 0 -45 12 -22 10 -21 78 -24 l52
-2 0 73 c0 64 -3 75 -22 88 -22 15 -54 19 -90 9z m72 -113 c0 -14 -7 -20 -23
-20 -30 0 -40 10 -26 27 18 20 49 16 49 -7z"/>
<path d="M3264 2241 c-2 -2 -4 -42 -4 -88 0 -75 2 -83 19 -83 16 0 19 9 23 60
5 68 19 91 46 74 12 -8 19 -29 22 -70 4 -46 9 -60 23 -62 15 -3 17 5 17 71 0
92 -12 106 -88 104 -30 -1 -56 -4 -58 -6z"/>
<path d="M3472 2230 c-49 -46 -32 -142 28 -155 44 -10 89 9 90 36 0 14 -32 18
-49 7 -29 -18 -51 -3 -51 35 0 45 22 64 56 48 28 -12 44 -7 44 13 0 15 -42 36
-74 36 -12 0 -32 -9 -44 -20z"/>
<path d="M3808 2234 c-1 -9 -2 -49 0 -90 3 -66 6 -74 23 -74 18 0 20 6 17 87
-2 73 -6 88 -20 91 -9 2 -18 -4 -20 -14z"/>
<path d="M1874 1943 c-22 -15 -26 -53 -9 -79 13 -20 23 -24 47 -22 42 4 47 23
7 23 -39 0 -59 26 -39 50 9 11 24 15 42 13 18 -3 27 0 25 6 -4 13 -57 19 -73
9z"/>
<path d="M1987 1932 c-47 -51 20 -120 76 -78 20 15 23 66 5 84 -18 18 -63 14
-81 -6z m72 -16 c20 -24 -4 -58 -37 -54 -27 3 -39 25 -28 54 7 18 50 18 65 0z"/>
<path d="M2112 1895 c-1 -32 2 -55 8 -55 5 0 10 17 10 38 l1 37 30 -37 c17
-21 35 -38 40 -38 5 0 9 25 9 55 0 30 -4 55 -10 55 -5 0 -10 -16 -10 -37 l0
-36 -31 36 c-17 21 -35 37 -38 37 -4 0 -8 -25 -9 -55z"/>
<path d="M2240 1895 c0 -30 5 -55 10 -55 6 0 10 14 10 30 0 37 5 37 37 0 13
-17 29 -28 34 -24 12 7 11 104 -1 104 -5 0 -10 -17 -10 -37 l-1 -38 -30 38
c-17 20 -35 37 -40 37 -5 0 -9 -25 -9 -55z"/>
<path d="M2370 1895 l0 -55 40 0 c22 0 40 5 40 10 0 6 -13 10 -30 10 -39 0
-41 27 -2 33 l27 4 -27 2 c-18 0 -28 7 -28 16 0 14 17 20 48 16 6 -1 12 3 12
9 0 5 -18 10 -40 10 l-40 0 0 -55z"/>
<path d="M2483 1924 c-15 -24 -15 -29 -2 -53 11 -20 22 -26 49 -26 18 0 35 6
37 12 3 9 -4 11 -24 7 -20 -4 -33 -1 -43 11 -19 23 -1 50 34 50 15 -1 26 5 26
12 0 8 -12 13 -30 13 -21 0 -35 -8 -47 -26z"/>
<path d="M2585 1940 c3 -5 13 -10 21 -10 10 0 14 -12 14 -45 0 -25 5 -45 10
-45 6 0 10 20 10 45 0 33 4 45 15 45 8 0 15 5 15 10 0 6 -21 10 -46 10 -27 0
-43 -4 -39 -10z"/>
<path d="M2700 1895 c0 -30 4 -55 8 -55 5 0 10 25 11 55 1 32 -3 55 -9 55 -6
0 -10 -24 -10 -55z"/>
<path d="M2754 1895 c0 -30 3 -55 8 -55 4 0 8 14 8 30 0 17 4 30 10 30 5 0 19
-13 32 -30 12 -16 25 -30 30 -30 4 0 8 25 8 55 0 30 -4 55 -10 55 -5 0 -10
-13 -10 -30 0 -16 -4 -30 -8 -30 -5 0 -18 14 -30 30 -13 17 -26 30 -30 30 -5
0 -8 -25 -8 -55z"/>
<path d="M2898 1939 c-21 -12 -24 -69 -6 -87 20 -20 66 -15 79 9 8 15 8 24 0
32 -8 8 -11 5 -11 -12 0 -18 -5 -22 -27 -19 -24 3 -28 8 -28 33 0 27 3 30 33
30 17 0 31 4 29 10 -5 14 -49 17 -69 4z"/>
<path d="M3066 1935 c-22 -22 -20 -58 3 -79 22 -20 62 -18 69 3 3 9 0 11 -7 6
-7 -4 -23 -4 -37 -1 -20 5 -25 12 -22 34 3 23 8 27 36 27 17 0 31 4 29 10 -6
17 -54 17 -71 0z"/>
<path d="M3188 1939 c-25 -14 -24 -75 1 -89 29 -15 56 -12 74 8 47 52 -14 117
-75 81z m60 -21 c20 -20 14 -47 -12 -54 -14 -3 -30 -3 -35 1 -12 7 -15 48 -4
58 10 11 38 8 51 -5z"/>
<path d="M3310 1894 c0 -37 4 -53 11 -48 6 3 8 17 5 30 -8 29 10 32 19 4 3
-11 12 -20 20 -20 8 0 17 9 20 20 9 29 28 25 23 -5 -3 -14 -1 -28 3 -31 5 -3
9 20 9 50 0 31 -4 56 -8 56 -4 0 -16 -14 -26 -31 l-19 -32 -18 24 c-10 13 -19
27 -19 32 0 4 -4 7 -10 7 -5 0 -10 -25 -10 -56z"/>
<path d="M3460 1895 c0 -30 5 -55 10 -55 6 0 10 15 10 33 l0 32 20 -25 20 -25
20 25 20 25 0 -32 c0 -18 5 -33 10 -33 6 0 10 25 10 55 0 30 -3 55 -6 55 -9 0
-44 -41 -44 -52 0 -17 -16 -7 -35 22 -11 16 -23 30 -27 30 -5 0 -8 -25 -8 -55z"/>
<path d="M3610 1914 c0 -63 26 -87 74 -68 12 5 16 19 14 58 l-1 51 -6 -45 c-5
-40 -9 -45 -31 -45 -22 0 -25 5 -28 43 -4 51 -22 57 -22 6z"/>
<path d="M3740 1895 c0 -61 17 -76 22 -18 l3 37 25 -37 c35 -52 46 -47 41 20
-5 56 -5 57 -10 18 l-6 -40 -30 37 c-16 21 -33 38 -37 38 -5 0 -8 -25 -8 -55z"/>
<path d="M3870 1895 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z"/>
<path d="M3914 1943 c4 -5 13 -8 19 -8 7 0 13 -20 15 -47 4 -64 22 -61 22 3 0
28 4 48 9 44 5 -3 12 -1 16 5 4 6 -12 10 -41 10 -26 0 -44 -3 -40 -7z"/>
<path d="M4027 1914 c-3 -19 -2 -45 3 -57 10 -26 10 -26 17 41 5 58 -11 72
-20 16z"/>
<path d="M4080 1895 l0 -55 40 0 c22 0 40 5 40 10 0 6 -13 10 -30 10 -20 0
-30 5 -30 15 0 9 10 15 26 15 15 0 23 4 19 10 -4 6 -14 9 -23 8 -9 -2 -18 5
-20 16 -3 15 1 18 22 14 15 -3 29 -1 32 3 3 5 -13 9 -35 9 l-41 0 0 -55z"/>
<path d="M4190 1935 c-15 -19 1 -42 32 -47 12 -2 24 -9 26 -17 4 -11 -3 -13
-32 -8 -27 4 -36 3 -33 -6 5 -17 49 -20 70 -5 22 16 13 48 -13 48 -26 0 -45
26 -25 34 8 3 22 3 30 0 8 -4 15 -1 15 5 0 16 -56 13 -70 -4z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
